import React, { useEffect } from 'react';
import { X, UserCircle } from 'lucide-react';
import UserProfileFields from './UserProfileFields';
import '../pm/pm-shared.css';
import './ProfileSettingsModal.css';

interface Props {
  onClose: () => void;
}

const ProfileSettingsModal: React.FC<Props> = ({ onClose }) => {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  return (
    <div className="profile-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="profile-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="profile-modal-title"
      >
        <header className="profile-modal-header">
          <div className="profile-modal-header-text">
            <div className="profile-modal-icon" aria-hidden>
              <UserCircle size={18} />
            </div>
            <div>
              <h2 id="profile-modal-title">Profile</h2>
              <p>Contact info and timezone for comment hover cards.</p>
            </div>
          </div>
          <button
            type="button"
            className="profile-modal-close"
            onClick={onClose}
            aria-label="Close profile settings"
          >
            <X size={18} />
          </button>
        </header>
        <div className="profile-modal-body">
          <UserProfileFields />
        </div>
      </div>
    </div>
  );
};

export default ProfileSettingsModal;
